import { ReactNode } from "react";
import { View } from "./View";

export interface IGrayBackgroundProps {
  children: ReactNode;
}

export const GrayBackground = (props: IGrayBackgroundProps) => {
  return <View {...props} />;
};
